// ------------------------------------
// Ordem de Exibição
// ------------------------------------
(function ($) {
  'use strict';

  // Altera a ordem de exibição
  $('.altera-ordem').on('change', function () {
    const valor = $(this).val().split('|');
    $('#input-ordem-id').val(valor[0]);
    $('#input-ordem-atual').val(valor[1]);
    $('#input-ordem-nova').val(valor[2]);
    atualizaOrdemExibicao();
  });

  // Processa a alteração de ordem de exibição
  function atualizaOrdemExibicao() {
    // Variáveis
    let enviando = false;
    const formulario = $('#form-ordem');
    $.ajax({
      url: formulario.attr('action'),
      type: formulario.attr('method'),
      data: formulario.serialize(),
      beforeSend: function () {
        showLoader();
        enviando = true;
      },
      success: function (resp) {
        console.log(resp);
        resp = JSON.parse(resp);
        if (resp.status == 'success') {
          location.reload();
        } else {
          enviando = false;
          hideLoader();
          Toast.fire({
            type: 'error',
            title: resp.mensagem,
          });
        }
      },
      error: function (resp) {
        console.log(resp);
        enviando = false;
        hideLoader();
        Toast.fire({
          type: 'error',
          title: 'Não foi possível realizar esta operação.',
        });
      },
    });
  }
})(jQuery);
